// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../config/api";
import config from "../../config/config";
import { getCurrentLoggedInSessionToken } from "../../config/userPool";

const {
  SHUTTLE_BUS_BOOKING_SET_STATION_LISTING_ENDPOINT,
  SHUTTLE_BUS_BOOKING_SET_STATION_DETAIL_ENDPOINT,
  SHUTTLE_BUS_BOOKING_SET_STATION_DELETE_ENDPOINT,
  AUDIT_ENDPOINT,

} = config.api_endpoint;

const initialState = {
  loading: false,
  set_station_list: [],
  error: null,
  detail_loading: false,
  detail_data: {},
  detail_error: null,
  audit_data: [],
  audit_loading: false,
  audit_error: null,
};


export const fetchSetStationList = createAsyncThunk(
  "SetStation/fetchSetStationList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${SHUTTLE_BUS_BOOKING_SET_STATION_LISTING_ENDPOINT}`;


      const results = await api.get(url, {}, token);

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchSetStationDetail = createAsyncThunk(
  "SetStation/fetchSetStationDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        SHUTTLE_BUS_BOOKING_SET_STATION_DETAIL_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const createAndUpdateSetStation = createAsyncThunk(
  "SetStation/createAndUpdateSetStation",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();

      if (id) {
        const results = await api.put(
          `${SHUTTLE_BUS_BOOKING_SET_STATION_LISTING_ENDPOINT}/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      } else {
        const results = await api.post(
          `${SHUTTLE_BUS_BOOKING_SET_STATION_LISTING_ENDPOINT}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      }


    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const fetchSetStationAudit = createAsyncThunk(
  "SetStation/fetchSetStationAudit",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const url = `${AUDIT_ENDPOINT}?table_name=bus_booking-station&source_id=${id}`;
      const results = await api.get(url, {}, token);
      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const deleteSetStationById = createAsyncThunk(
  "SetStation/deleteSetStationById",
  async (id, { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
        SHUTTLE_BUS_BOOKING_SET_STATION_DELETE_ENDPOINT + "/" + id,
        JSON.stringify({ }),
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



const SetStationSlice = createSlice({
  name: "set-station",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSetStationDetail.pending, (state) => {
        state.detail_loading = true;
      })
      .addCase(fetchSetStationDetail.fulfilled, (state, action) => {
        state.detail_loading = false;
        state.detail_data = action.payload;
      })
      .addCase(fetchSetStationDetail.rejected, (state, action) => {
        state.detail_loading = false;
        state.detail_error = action.error.message;
      })
      .addCase(fetchSetStationAudit.pending, (state) => {
        state.audit_loading = true;
      })
      .addCase(fetchSetStationAudit.fulfilled, (state, action) => {
        state.audit_loading = false;
        state.audit_data = action.payload;
      })
      .addCase(fetchSetStationAudit.rejected, (state, action) => {
        state.audit_loading = false;
        state.audit_error = action.error.message;
      })
      .addCase(fetchSetStationList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSetStationList.fulfilled, (state, action) => {
        state.loading = false;
        state.set_station_list = action.payload;
      })
      .addCase(fetchSetStationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(deleteSetStationById.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSetStationById.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteSetStationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

const ShuttleBusSetStationReducer = SetStationSlice.reducer;
export default ShuttleBusSetStationReducer;
